import { format, parse, isValid, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';

export const formatDateForDisplay = (isoString: string, timezone: string): string => {
  try {
    // Parse the UTC date from ISO string
    const utcDate = parseISO(isoString);
    // Convert UTC to user's timezone
    const zonedDate = utcToZonedTime(utcDate, timezone);
    // Format in the user's timezone
    return format(zonedDate, 'dd/MM/yyyy HH:mm');
  } catch {
    console.error('Error formatting date');
    return '';
  }
};

export const formatDateWithTimezone = (isoString: string, timezone: string, formatStr: string): string => {
  try {
    const utcDate = parseISO(isoString);
    const zonedDate = utcToZonedTime(utcDate, timezone);
    return format(zonedDate, formatStr, { locale: es });
  } catch {
    console.error('Error formatting date with timezone');
    return '';
  }
};

export const parseUserInput = (input: string, timezone: string): { date: Date | null; error: string | null } => {
  try {
    if (!/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/.test(input)) {
      return { date: null, error: 'Formato inválido. Use dd/MM/yyyy HH:mm' };
    }

    const localDate = parse(input, 'dd/MM/yyyy HH:mm', new Date());
    if (!isValid(localDate)) {
      return { date: null, error: 'Fecha inválida' };
    }

    // Convert the local date to UTC considering the timezone
    const utcDate = zonedTimeToUtc(localDate, timezone);
    return { date: utcDate, error: null };
  } catch {
    return { date: null, error: 'Error al procesar la fecha' };
  }
};

export const convertToUTC = (date: Date, timezone: string): string => {
  return zonedTimeToUtc(date, timezone).toISOString();
};

export const convertToZonedTime = (date: Date | string, timezone: string): Date => {
  const utcDate = typeof date === 'string' ? parseISO(date) : date;
  return utcToZonedTime(utcDate, timezone);
};